import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import BannerCodeModal from './banner-code-modal';
import PageHeader from '../../../shared/page-header/components/page-header';
import RenderIf from '../../../shared/render-if/components/render-if';
import Banner from './banner';
import Button from '../../../shared/button/components/button';
import ButtonsSelector from '../../../shared/buttons-selector/components/buttons-selector';
import CreateCampaignModal from '../../campaigns/components/create-campaign-modal';
import ChooseCampaignModal from '../../campaigns/components/choose-campaign-modal';
import MobileCampaignModal from '../../campaigns/components/mobile-campaign-modal';
import bannerConstants from '../constants/banners-constants';
import Helpers from '../../../../common/helpers';
import BannerHelpers from '../helpers/banner-helpers';
import constants from '../../../../common/constants';

import '../styles/banners.css';

class Banners extends Component {
  state = {
    bannerType: bannerConstants.banner_types.copy_trader,
    bannerLanguage: constants.languages.en,
    type: null,
    language: null,
  };

  onTypeChange(bannerType) {
    this.setState({ type: bannerType.value });
  }

  onLanguageChange(bannerLanguage) {
    this.setState({ language: bannerLanguage.value });
  }

  renderBanners(banners, links) {
    return banners.map((banner, index) => {
      return <Banner {...banner} links={links} key={index} />;
    });
  }

  downloadBanners(type, language) {
    const url = BannerHelpers.formBannersDownloadUrl(type, language);
    window.open(url, '_blank');
  }

  filterByCountry(banners) {
    const { profile } = this.props;

    const filteredBanners = banners.filter(banner => {
      if (profile && profile.country) {
        return banner.countries.find(country => country === profile.country || country === '*');
      }
      return false;
    });

    return filteredBanners;
  }

  render() {
    const { campaigns, showBannerCodeModal, profile } = this.props;
    const { bannerType, bannerLanguage, type, language } = this.state;
    const bannerTypes = _.values(bannerConstants.banner_types);
    const selectedType = type ? _.find(bannerTypes, { value: type }) : bannerType;
    const banners = Helpers.getBanners(type || bannerType.value, language || bannerLanguage.value, selectedType, selectedType.imageType);

    return (
      <div className="banners-container">
        <RenderIf if={campaigns && showBannerCodeModal}>
          <BannerCodeModal reason={selectedType.reason} />
        </RenderIf>
        <RenderIf if={profile}>
          <ChooseCampaignModal />
        </RenderIf>
        <RenderIf if={profile}>
          <CreateCampaignModal />
        </RenderIf>
        <MobileCampaignModal />
        <div className="display-flex-vertical">
          <PageHeader title={'BANNERS.TITLE'} />
          <Button
            label={'BANNERS.DOWNLOAD_BANNERS'}
            translationVariables={{ lang: language || bannerLanguage.value }}
            customClass={'banners-container__download-btn'}
            icon={'glyphicon-download-alt'}
            onClick={() => this.downloadBanners(type || bannerType.value, language || bannerLanguage.value)}
          />
        </div>
        <div className="row text-center">
          <div className="col-sm-12">
            <ButtonsSelector items={this.filterByCountry(bannerTypes)} selectedValue={bannerType} onClick={item => this.onTypeChange(item)} />
          </div>
          <div className="m-t-20 display-flex-center col-sm-12">
            <div className="col-md-12 col-sm-12">
              <ButtonsSelector items={selectedType.languages} selectedValue={bannerLanguage} onClick={item => this.onLanguageChange(item)} />
            </div>
          </div>
        </div>
        <div className="row banners-container__body">{this.renderBanners(banners)}</div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.userProfileReducer.profile,
  campaigns: state.campaignsReducer.campaigns,
  showBannerCodeModal: state.bannersReducer.showBannerCodeModal,
});

const mapDispatchToProps = dispatch => ({});

Banners.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Banners);



// WEBPACK FOOTER //
// ./src/app/main/banners/components/banners.js